import CommonRadioMulSelect from '../CommonRadioMulSelect';
import React from 'react';

const ConsentAttribute = (props) => {
  const {
    selectOptions,
    radioName,
    selectName,
    noStyle,
    disabled,
    hasExclude,
  } = props;
  return (
    <CommonRadioMulSelect
      selectOptions={selectOptions}
      radioName={radioName}
      selectName={selectName}
      noStyle={noStyle}
      hasExclude={hasExclude}
      disabled={disabled}
    />
  );
};
export default ConsentAttribute;
